import React from 'react';
import { Button } from './ui/button';
import { heroImages } from '../data/mockData';

const HeroSection = ({ onBookingClick, onViewDressesClick }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 bg-neutral-950">
      {/* Background Grid of Images */}
      <div className="absolute inset-0 grid grid-cols-2 md:grid-cols-3 gap-0 opacity-30">
        {heroImages.map((img, index) => (
          <div key={index} className="relative h-full overflow-hidden">
            <img
              src={img}
              alt="Morea dress collection"
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/85 via-neutral-950/75 to-neutral-950/95"></div>

      {/* Content */}
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight tracking-tight">
            Encuentra el vestido perfecto en Morea Ecuador
          </h1>
          <p className="text-lg sm:text-xl text-neutral-300 mb-10 max-w-3xl mx-auto font-light leading-relaxed">
            Alquiler de vestidos de diseñador para grados, matrimonios, galas, cocteles y eventos especiales. Agenda tu cita en Quito o Guayaquil y vive la experiencia Morea.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={onBookingClick}
              className="bg-white hover:bg-neutral-100 text-neutral-900 px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl hover:scale-105 w-full sm:w-auto"
            >
              Agenda tu cita
            </Button>
            <Button
              onClick={onViewDressesClick}
              variant="outline"
              className="border-2 border-white text-white bg-transparent hover:bg-white hover:text-neutral-900 px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl w-full sm:w-auto"
            >
              Ver vestidos
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-neutral-400 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-1.5 bg-neutral-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
